import { render, staticRenderFns } from "./SetupDeliveryView.vue?vue&type=template&id=573712ea&"
import script from "./SetupDeliveryView.vue?vue&type=script&lang=js&"
export * from "./SetupDeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./SetupDeliveryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports